<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Antrian Per Poli
                </h1>
            </div>
            <div class="w-full mt-5 text-center mb-5">
                <p class="font-poppins font-bold text-xl">
                    NAMA POLI: {{ poli.FS_NM_LAYANAN }}
                </p>
            </div>
            <div class="font-poppins mt-5">
                <p class="font-sm">
                    data diperbaharui pada :
                    <span class="text-red-500">{{ timerCount }}</span>
                </p>
            </div>
            <div class="w-full">
                <div
                    class="w-full md:grow mr-10"
                    v-if="tracingAntrianPoliDetailData"
                >
                <div class="w-1/2 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                    <table
                        class="w-full whitespace-nowrap"
                    >
                        <tr class="text-left font-bold bg-amber-100">
                            <td class="py-2 px-3 text-center text-sm" colspan="2">
                                Dokter
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="2">
                                Tanggal
                            </td>
                        </tr>
                        <tr class="hover:bg-gray-100">
                            <td class="py-2 px-3 text-center text-sm" colspan="2">
                                {{ tracingAntrianPoliDetailData.dokter }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="2">
                                {{ tracingAntrianPoliDetailData.tgl_antrian }}
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="w-1/2 mt-5 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                    <table
                        class="w-full whitespace-nowrap"
                    >
                        <tr class="text-left font-bold bg-amber-100">
                            <td class="py-2 px-3 text-center text-sm" colspan="2">
                                No Antrian
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="2">
                                Nama
                            </td>
                        </tr>
                        <tr class="hover:bg-gray-100">
                            <td class="py-2 px-3 text-center text-sm" colspan="2">
                                {{ tracingAntrianPoliDetailData.no_urut }}
                            </td>
                            <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer" colspan="2">
                                {{ tracingAntrianPoliDetailData.nama_pasien }}
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="w-3/4 mt-5 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                    <table class="w-full whitespace-nowrap">
                        <thead>
                            <tr class="text-left font-bold bg-amber-100">
                                <th class="py-2 px-3 text-center text-sm"></th>
                                <th class="py-2 px-3 text-center text-sm">Nama Status</th>
                                <th class="py-2 px-3 text-center text-sm">Jam/Tanggal</th>
                                <th class="py-2 px-3 text-center text-sm">Lokasi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">1</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">CEKIN</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ tracingAntrianPoliDetailData.jam_jkn_cekin }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">ANJUNGAN</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">2</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">PANGGIL (TTV)</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ tracingAntrianPoliDetailData.jam_panggil_ttv }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">POLIKLINIK</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">3</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">PERIKSA</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ tracingAntrianPoliDetailData.jam_masuk }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">POLIKLINIK</td>
                            </tr>
                            <tr class="hover:bg-gray-100">
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">4</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer uppercase">SELESAI {{tracingAntrianPoliDetailData.ket_selesai}}</td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                    {{ tracingAntrianPoliDetailData.jam_keluar }}
                                </td>
                                <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">POLIKLINIK</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutNoHeader from "../Shared/LayoutNoHeader.vue";
import RandomShape from "../Shared/RandomShape.vue";
export default {
    data() {
        return {
            tracingAntrianPoliDetailData: this.tracingAntrianPoliDetail,
            timerCount: 10,
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getAntrianPoliTracingDetail();
                }
            },
            immediate: true,
        },
    },
    methods: {
        getAntrianPoliTracingDetail() {
            this.$inertia.get(
                `/antrian/${this.poli.FS_KD_LAYANAN}/${this.tracingAntrianPoliDetailData.no_urut}/ajax`,
                {},
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.tracingAntrianPoliDetailData = page.props.additional.tracingAntrianPoliDetail;
                        this.timerCount= 10;
                    },
                }
            );
        }
    },
    components: {
        Link,
        RandomShape,
    },
    props: {
        tracingAntrianPoliDetail: Object,
        poli: Object,
    },
    layout: LayoutNoHeader,
};
</script>
